import { render, staticRenderFns } from "./UmsApplicationLongTimeTokenGenerator.vue?vue&type=template&id=72988278&"
import script from "./UmsApplicationLongTimeTokenGenerator.vue?vue&type=script&lang=js&"
export * from "./UmsApplicationLongTimeTokenGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports